import { useTranslation } from 'react-i18next'

import { OpportunityForm as F } from '@percent/domain/volunteering'

export function NameField(props: Omit<F.NameFieldProps, 'label' | 'placeholder'>) {
  const { t } = useTranslation()

  return (
    <F.NameField
      {...props}
      label={t('volunteering.opportunity.form.common.overviewSection.nameField.label')}
      placeholder={t('volunteering.opportunity.form.common.overviewSection.nameField.placeholder')}
    />
  )
}
